export const IMG = {
  heroInterior:
    "https://images.unsplash.com/photo-1633681926022-84c23e8cb2d6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  heroBlowout:
    "https://images.unsplash.com/photo-1564141696939-9eb6e957ccfc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  salonAlt:
    "/api/files/malek-dridi/salon/55f4ca617f3441aab9530b87c94dd5db.jpg",
  stylingProcess:
    "https://images.unsplash.com/photo-1560869713-bf165a9cfac1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  extensionsService:
    "https://images.unsplash.com/photo-1634449571017-5fecfd26ad76?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  productsShelf:
    "https://images.unsplash.com/photo-1553855994-da8397e155c7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  productCloseup:
    "https://images.unsplash.com/photo-1631729371254-42c2892f0e6e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  blonde:
    "https://images.unsplash.com/photo-1519699047748-de8e457a634e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  brunette:
    "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  balayage:
    "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  updo:
    "https://images.unsplash.com/photo-1595475207225-428b62bda831?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  classroom:
    "/api/files/malek-dridi/academy/473b9f82ed884c75b945f6632a84e47b.jpg",
  detail:
    "https://images.unsplash.com/photo-1605497788044-5a32c7078486?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const HAIR_SERVICES = [
  {
    slug: "colour",
    name: "Colour",
    blurb: "Bespoke, dimensional colour crafted to complement your tone.",
    from: "£70",
    duration: "2h 30m",
    image: "/api/files/malek-dridi/services/4d2b88d3fe52435d9f3bcdbc77ce366e.jpg",
  },
  {
    slug: "highlights",
    name: "Highlights",
    blurb: "Hand-painted lightening with luminous, sun-kissed dimension.",
    from: "£75",
    duration: "3h",
    image: "/api/files/malek-dridi/services/abe9f8368ceb4357b9372226cd3aea32.jpg",
  },
  {
    slug: "balayage",
    name: "Balayage",
    blurb: "Seamless colour melts for a soft, lived-in finish.",
    from: "£80",
    duration: "3h 30m",
    image: "/api/files/malek-dridi/services/2996c74d11494c87ba0f9bd310a734e6.jpg",
  },
  {
    slug: "cuts",
    name: "Cuts",
    blurb: "Precision cutting sculpted around your face and lifestyle.",
    from: "£35",
    duration: "1h",
    image: "/api/files/malek-dridi/services/236cbfb2ade04148bfd89befda059485.jpg",
  },
  {
    slug: "blowdries",
    name: "Blowdries",
    blurb: "Silky, voluminous blowouts finished to editorial standard.",
    from: "£25",
    duration: "45m",
    image: "/api/files/malek-dridi/services/acca03cedf7d4ac39850f6e91b84bbf4.jpg",
  },
  {
    slug: "treatments",
    name: "Hair Treatments",
    blurb: "Restorative rituals that repair, condition and add shine.",
    from: "£20",
    duration: "45m",
    image: "/api/files/malek-dridi/services/5cc8374a4d3b4f1f9cfaa9e2719b68be.jpg",
  },
];

export const EXTENSION_METHODS = [
  {
    slug: "nano-bonds",
    name: "Nano Bonds",
    tag: "Discreet · Micro",
    blurb:
      "Our smallest, most invisible attachment — perfect for fine hair and undetectable placement.",
    image: "/api/files/malek-dridi/extensions/5e37d921b7774cb3ae2cfc4c2d5c29e3.jpg",
  },
  {
    slug: "custom-k-tips",
    name: "Custom K-Tips",
    tag: "Bespoke · Micro",
    blurb:
      "Hand-tailored keratin-tip bonds fitted strand-by-strand for a fully bespoke, natural finish.",
    image: "/api/files/malek-dridi/extensions/e4ca7f2efd514566822d255239484e3a.jpg",
  },
  {
    slug: "weaves",
    name: "Weaves",
    tag: "Volume · Length",
    blurb:
      "Traditional sew-in weaves for dramatic length and thickness with zero glue.",
    image: "/api/files/malek-dridi/extensions/ae609f897b0843678ab68ef9716dfb11.jpg",
  },
  {
    slug: "genius-wefts",
    name: "Genius Wefts",
    tag: "Innovative",
    blurb:
      "Next-generation hand-tied wefts — ultra-thin, cuttable and endlessly customisable.",
    image: "/api/files/malek-dridi/extensions/df1d12f7e4ae4d4cacac58aef77af4cf.jpg",
  },
  {
    slug: "keratin-bonds",
    name: "Keratin Bonds",
    tag: "Long-wearing",
    blurb:
      "Individual keratin-tipped strands fused for movement, longevity and swim-safe wear.",
    image: IMG.brunette,
  },
  {
    slug: "maintenance",
    name: "Maintenance",
    tag: "Aftercare",
    blurb:
      "Move-ups, refits and repositioning to keep your extensions salon-fresh.",
    image: IMG.detail,
  },
];

export const HAIR_LOSS = [
  {
    slug: "mesh-integration",
    name: "Mesh Integration",
    blurb:
      "A breathable, non-surgical solution woven into your existing hair for full coverage and volume.",
    image: "/api/files/malek-dridi/services/d8c412e21f424612bc928ff9ab632213.webp",
  },
  {
    slug: "partial-mesh",
    name: "Partial Mesh",
    blurb:
      "Targeted mesh systems for thinning areas — light, secure and completely natural in movement.",
    image: "/api/files/malek-dridi/services/3ce2086fb8824d5f8bb8f6ea983c593d.jpg",
  },
  {
    slug: "hair-toppers",
    name: "Hair Toppers",
    blurb:
      "Premium clip-in toppers colour-matched to your hair to add instant density on the crown.",
    image: "/api/files/malek-dridi/hairloss/4e8bcb4ea95b422fa93da8d016bb5325.jpg",
  },
  {
    slug: "consultations",
    name: "Private Consultations",
    blurb:
      "Confidential, one-to-one consultations to walk you through the right solution for your journey.",
    image: "/api/files/malek-dridi/hairloss/7b5a730a4dfa4d9c8365a103927b52fa.jpg",
  },
];

export const REVIEWS = [
  {
    name: "Mirren Hannah",
    source: "Google",
    stars: 5,
    text:
      "Always felt so comfortable in Malek's salon. Always a good time and great results! Highly recommend. I've also done a blow dry masterclass and loved it — helped me so much. Will be doing further training at the Nook Academy in future x",
  },
  {
    name: "Erin A.",
    source: "Google",
    stars: 5,
    text:
      "Most welcoming salon with a fantastic atmosphere — wouldn't go anywhere else. Malek absolutely fantastic 🫶🏻🫶🏻",
  },
  {
    name: "Leanne Feeney",
    source: "Facebook",
    stars: 5,
    text:
      "What can I say?!? Malek is a magician! Every single time I leave her salon, I leave with a smile. Nothing is too big or too small. Malek just gets me! Listens to what I want and follows through. Wouldn't go anywhere else now 🫶",
  },
  {
    name: "Don Na",
    source: "Facebook",
    stars: 5,
    text:
      "Malek is a genius! So knowledgeable and talented! The best consultation I have ever had and instantly knew I wanted Malek to take control of my disaster hair — and she did not disappoint 🙌 Thank you so much for giving me my confidence back and for my amazing hair transformation ❤️ Highly recommend and won't go anywhere else now I have found Malek xx",
  },
  {
    name: "Natasha Falconer",
    source: "Facebook",
    stars: 5,
    text:
      "I trained with Malek on the Bouncy Blow Dry Masterclass and, as a complete beginner in hair, I couldn't have asked for a better experience. Malek was amazing from start to finish — clearly explaining the products, the brushes, and even how to hold the hairdryer properly to achieve the perfect blowout. I learned so much and felt supported every step of the way. I highly recommend the training programme. You are incredible, thank you again — I absolutely loved it! xxx",
  },
  {
    name: "Alison Munro",
    source: "Facebook",
    stars: 5,
    text:
      "I met Malek for the first time this week and have honestly never felt so welcomed and comfortable in my life. I can be quite socially anxious but she made me feel like I could just be myself and relax. I'm absolutely delighted with my hair and felt that Malek really cared about making sure I was happy. There was no rushed feeling, and no awkward silences. From now on I'll only go to Malek for my hair and would 100% recommend this beautiful soul to anyone. Much love to you sweetheart 🥰😘",
  },
  {
    name: "Chloe M.",
    source: "Google",
    stars: 5,
    text:
      "I trained on the hair extension course and it changed my career. The teaching is next level and Malek gives you everything.",
  },
  {
    name: "Priya S.",
    source: "Google",
    stars: 5,
    text:
      "After years of thinning, the mesh integration gave me back my confidence. Handled with total care and discretion.",
  },
];

export const FAQ = [
  {
    q: "How do I book an appointment?",
    a: "You can book directly through our online booking system via the Book Appointment button. New extension clients begin with a complimentary consultation.",
  },
  {
    q: "How long do hair extensions last?",
    a: "With proper care and maintenance, our extensions can be reused for 6 to 12 months. We recommend a move-up every 8–10 weeks.",
  },
  {
    q: "Do you offer training courses?",
    a: "Yes — our Academy runs accredited, small-group courses for future and established stylists. Browse the full course list, view prices and enrol directly on the Academy page.",
  },
  {
    q: "What is your cancellation policy?",
    a: "We require 48 hours notice for cancellations or rescheduling. A 50% booking fee secures your appointment.",
  },
  {
    q: "Do you consult on hair loss?",
    a: "Absolutely. We offer private, confidential consultations for mesh integration, toppers and thinning-hair solutions.",
  },
];

export const INSTA_TILES = [
  "/api/files/malek-dridi/graduates/8c913121f856432ca8ca9638a52bbfef.jpg",
  "/api/files/malek-dridi/graduates/ebf29be2c9df4d679ebf5879768c0d8a.jpg",
  "/api/files/malek-dridi/graduates/01f62664011e4bd891f9e4ece31f7752.jpg",
  "/api/files/malek-dridi/graduates/f67713be5a1f40c985bd0f4769bcefa3.jpg",
  "/api/files/malek-dridi/graduates/b734f9b9b34d47bbb1a6a3cc18572dad.jpg",
  "/api/files/malek-dridi/graduates/8c4aaa8860404bc8a1bc51cc5ac604c1.jpg",
  "/api/files/malek-dridi/graduates/f376877b987f4a1ba768883a3ad28f30.jpg",
  "/api/files/malek-dridi/graduates/46e94e093d3e4600be0f3afa43a745ab.jpg",
  "/api/files/malek-dridi/graduates/7ab82daad00e4fe1901a81f6ada2449c.jpg",
];
